import React, { Component } from 'react';
import { toast, getMultiLang } from '@platform/api';
import ComponentLoader from '../ComponentLoader';

require('./index.less');

export default class Attachment extends Component {
    constructor(props) {
        super(props);
        this.state = { showUploader: false };

    }

    componentDidMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'base_attachment', callback });
    }

    render() {
        let { showUploader } = this.state;
        let { onHide, fieldValue, disableModify, rowInfo, colInfo, getAttachmentValue, pkname } = this.props;
        let [num, billpk] = (fieldValue || '').split(',');

        return <span
            onClick={e => e.stopPropagation()}
            onDoubleClick={e => e.stopPropagation()}
            className="platform-base-attachment"
        >
            <span onClick={() => {
                if (disableModify) {
                    toast({
                        color: "warning",
                        content: this.state.json['base-attachment-0001'],
                    });
                } else {
                    if (typeof getAttachmentValue === "function") {
                        this.attachmentParams = { ...getAttachmentValue(rowInfo, colInfo) }; // 优先级：getAttachment领域/customize模板配置
                    }
                    this.setState({ showUploader: true });
                }
            }} className={"iconfont icon-icon-fujian " + (disableModify ? 'disabled' : 'active')} >({num || 0})</span>
            {showUploader && <ComponentLoader
                _path="../../../../uap/common/components/NCUploader/index.js"
                {...this.props}
                customize={{ ...this.props.customize, ...this.attachmentParams }}
                billId={billpk}
                onHide={(...rest) => {
                    this.setState({ showUploader: false });
                    typeof onHide === 'function' && onHide(...rest);
                }}
            />}
        </span>;
    }
}
